<app-environment-banner></app-environment-banner>

<header class="app-header">
  <div class="container">
    <div class="header-content">
      <div class="logo">
        <h1>Vortex Metrics Dashboard</h1>
      </div>
      @if (isAuthenticated$ | async) {
        <nav class="main-nav">
          <a routerLink="/dashboard" routerLinkActive="active">Dashboard</a>
          @if (hasAdminAccess) {
            <a routerLink="/admin" routerLinkActive="active">Admin</a>
          }
        </nav>
      }
      @if (isAuthenticated$ | async; as isAuth) {
        <div class="user-menu">
          <span class="user-name">{{ userName }}</span>
          <button class="btn btn-secondary" (click)="logout()">Logout</button>
        </div>
      }
      @if ((isAuthenticated$ | async) === false) {
        <div class="auth-buttons">
          <button class="btn btn-primary" (click)="login()">Login</button>
        </div>
      }
    </div>
  </div>
</header>

<main class="app-main">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</main>

<footer class="app-footer">
  <div class="container">
    <p>&copy; {{ currentYear }} Met Office. All rights reserved.</p>
  </div>
</footer>
